import { useMutation, useQueryClient } from "@tanstack/react-query";
import urls from "../urls";
import type { ExtendedUser } from "../utils/backend-types";
import { uploadFileOrFiles } from "../utils/files/uploadFileOrFiles";
import { QUERY_KEY } from "./useCurrentUserQuery";

export function useProfilePictureMutations() {
  const queryClient = useQueryClient();

  const editProfilePicture = useMutation({
    mutationFn: editProfilePictureRequest,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [QUERY_KEY]
      });
    }
  });

  return {
    editProfilePicture
  };
}

function editProfilePictureRequest(file: File) {
  return uploadFileOrFiles<ExtendedUser>(
    file,
    urls.apiWithoutCamelization.userProfile(),
    "image",
    undefined,
    "PATCH",
    true
  );
}
